import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { push } from 'connected-react-router';

import { Logger } from 'utils/Logger';

import { deleteFundingReport, deleteFundingReportNewHub } from './types';
import { requestDeleteFundingReportSuccess, requestDeleteFundingReportFailure } from './reducer';

import { requestDeleteCaseSuccess, requestDeleteCaseFailure } from '../../cases/actions';

const logger = new Logger('Saga:FundingReport');

export function* requestDeleteFundingReportNewHubSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { reportId } = action;

  try {
    const response = yield call(
      authApiService.delete,
      routerService.generate('api.funding_report_detail', { reportId }),
    );

    action.promise && action.promise.resolve(response.data);
    yield put(requestDeleteCaseSuccess(action.fundingSearchId, response.data));
    yield put(push('/cases'));
  } catch (error) {
    logger.error('Failed to request delete funding report with the following error', error);
    action.reject && action.promise.reject(error);
    yield put(requestDeleteCaseFailure(error));
  }
}

export function* requestDeleteFundingReportSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { reportId } = action;

  try {
    const response = yield call(
      authApiService.delete,
      routerService.generate('api.funding_report_detail', { reportId }),
    );

    action.promise && action.promise.resolve(response.data);
    yield put(requestDeleteFundingReportSuccess(reportId));
    yield put(push('/funding#funding-reports'));
  } catch (error) {
    logger.error('Failed to request delete funding report with the following error', error);
    action.reject && action.promise.reject(error);
    yield put(requestDeleteFundingReportFailure(error));
  }
}

export default function* deleteFundingReportSaga() {
  return yield all([
    takeLatest(deleteFundingReport.request, requestDeleteFundingReportSaga),
    takeLatest(deleteFundingReportNewHub.request, requestDeleteFundingReportNewHubSaga),
  ]);
}
